import { useState } from 'react';
import { faqs } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-4xl">
        <SectionHeading
          eyebrow="常见问题"
          title="关于本站与片单的常见疑问"
          desc="整理了几个新访客最常问的问题，点击标题即可展开查看。若仍有疑问，可结合页面其他分区一起理解。"
          align="center"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div key={item.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-700">
                      <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} aria-hidden="true"></i>
                    </span>
                  </button>
                </h3>
                {isOpen ? (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}